import { useState } from "react";
import { SNAP_FILTERS_VISIBLE } from "../config/snapFilters";

/**
 * @param {{ filter: import("../config/snapFilters").SnapFilterDefinition, isSelected: boolean, isLensLoading: boolean, onSelect: (filter: import("../config/snapFilters").SnapFilterDefinition) => void }} props
 */
function SnapFilterBarItem({ filter, isSelected, isLensLoading, onSelect }) {
  const [imageFailed, setImageFailed] = useState(false);
  const showImage = Boolean(filter.iconImage) && !imageFailed;
  const isLoading = isSelected && isLensLoading;

  return (
    <button
      type="button"
      role="option"
      aria-selected={isSelected}
      aria-busy={isLoading}
      disabled={isLensLoading}
      className={`snap-filter-bar__item${isSelected ? " snap-filter-bar__item--active" : ""}${isLoading ? " snap-filter-bar__item--loading" : ""}`}
      onClick={() => onSelect(filter)}
    >
      <span
        className="snap-filter-bar__icon"
        style={
          !showImage && filter.themeColor
            ? { backgroundColor: filter.themeColor }
            : undefined
        }
      >
        {showImage && (
          <img
            src={filter.iconImage}
            alt=""
            onError={() => setImageFailed(true)}
          />
        )}
        {isLoading && (
          <span className="snap-filter-bar__icon-spinner" aria-hidden="true" />
        )}
      </span>
      <span className="snap-filter-bar__label">{filter.name}</span>
    </button>
  );
}

/**
 * @param {{ selectedFilterId: string, isLensLoading: boolean, onSelect: (filter: import("../config/snapFilters").SnapFilterDefinition) => void }} props
 */
export default function SnapFilterBar({ selectedFilterId, isLensLoading, onSelect }) {
  return (
    <div className="snap-filter-bar" role="listbox" aria-label="Filter selection">
      <div className="snap-filter-bar__track">
        {SNAP_FILTERS_VISIBLE.map((filter) => (
          <SnapFilterBarItem
            key={filter.id}
            filter={filter}
            isSelected={selectedFilterId === filter.id}
            isLensLoading={isLensLoading}
            onSelect={onSelect}
          />
        ))}
      </div>
    </div>
  );
}
